import React, { ComponentProps, memo } from 'react'

import styled from '@emotion/styled'

import {
  useLayerManager,
  useOffsetManagerContext,
  mediaQueries,
  Box,
  absoluteCenter,
  AnimatedSurglogsLogo,
} from '@surglogs-app/ui'

const Screen = styled(Box)<{
  sidebarWidth: number
  hiddenSidebarWidth: number
  fullWidth: boolean
}>`
  position: fixed;
  width: ${({ sidebarWidth, fullWidth }) =>
    fullWidth ? '100%' : `calc(100% - ${sidebarWidth}px)`};
  height: 100%;
  top: 0;
  left: ${({ sidebarWidth, fullWidth }) =>
    fullWidth ? 0 : `${sidebarWidth}px`};
  background-color: ${({ theme }) => theme.ui.colors['transparent.90']};

  ${mediaQueries.sideBarCollapsed} {
    width: ${({ hiddenSidebarWidth, fullWidth }) =>
      fullWidth ? '100%' : `calc(100% - ${hiddenSidebarWidth}px)`};
    left: ${({ hiddenSidebarWidth, fullWidth }) =>
      fullWidth ? 0 : `${hiddenSidebarWidth}px`};
  }
`

const StyledContainer = styled(Box)`
  text-align: center;

  ${absoluteCenter()}
`

interface LogoLoaderProps
  extends Omit<
    ComponentProps<typeof Screen>,
    'hiddenSidebarWidth' | 'sidebarWidth' | 'fullWidth'
  > {
  fullWidth?: boolean
}

export const LogoScreenLoader = memo(
  ({ fullWidth = false, zi, ...rest }: LogoLoaderProps) => {
    const ctx = useLayerManager()
    const { sidebarWidth, hiddenSidebarWidth } = useOffsetManagerContext()

    return (
      <Screen
        {...{
          zi: zi ?? ctx.zIndex + 1,
          sidebarWidth,
          hiddenSidebarWidth,
          fullWidth,
          ...rest,
        }}>
        <StyledContainer>
          <Box {...{ position: 'relative' }}>
            <AnimatedSurglogsLogo />
          </Box>
        </StyledContainer>
      </Screen>
    )
  },
)
